// import axios from "axios";
// import http from "http";
import _ from "lodash";
// import moment from "moment";

const getUserConfig = async (emp_id) => {
    // let now = moment().toISOString();
    // let reqFilter = JSON.stringify({
    //     "where": {
    //         "and": [
    //             {"emp_id": emp_id},
    //             {"enabled": true},
    //             {"configSystem": "eup"},
    //             {"configStartDate": {"lt": now}},
    //             {"configEndDate": {"gt": now}}
    //         ]
    //     }
    // });
    let resp = {};
    // let resp = await axios.request({url: `https://stats.undash-cop.com/api/HeartBeatConfig?filter=${encodeURIComponent(reqFilter)}`,
    //   method: 'GET',
    //   headers: {
    //     'Content-Type':'application/json',
    //     'withCredentials': true, 
    //     'Access-Control-Allow-Origin': '*'
    //   },
    //   httpAgent: new http.Agent({ keepAlive: true })
    // });
    // resp = await resp.data;
    if (!_.isEmpty(resp)){
      return _.first(resp);
    } else {
      return [];
    }
  }

  export default getUserConfig;